<template>
  <div
    :class="{
      'error-product-card':
        itemData.modification &&
        itemData.modification.reason_id === MODIFICATION_REASON_ID.NOT_FOUND_IN_STOCK &&
        modifiedAs !== MODIFICATION_REASON.CHECKED,
      'is-loading': modifiedAs && hideCheckedProducts,
      'is-hidden': modifiedAs && modifyingEnded && hideCheckedProducts,
    }"
  >
    <v-container>
      <v-row>
        <div class="col-5 text-center">
          <img
            v-if="productImageUrl"
            loading="lazy"
            :src="productImageUrl"
            alt=""
            class="product-image w-100"
            @click="dialog = true"
          />
          <svg v-else xmlns="http://www.w3.org/2000/svg" height="150" viewBox="0 0 60 60">
            <title>image-placeholder</title>
            <rect fill="#efeeee" width="60" height="60" />
            <path
              fill="#fff"
              d="M41.5,19.38h-23A2.65,2.65,0,0,0,15.85,22V38a2.65,2.65,0,0,0,2.65,2.66h23A2.65,2.65,0,0,0,44.15,38V22A2.65,2.65,0,0,0,41.5,19.38ZM42.38,38a.88.88,0,0,1-.88.89h-23a.88.88,0,0,1-.88-.89V22a.88.88,0,0,1,.88-.89h23a.88.88,0,0,1,.88.89ZM22,28.67a3.1,3.1,0,1,0-3.1-3.09A3.09,3.09,0,0,0,22,28.67Zm0-4.42a1.33,1.33,0,1,1-1.33,1.33A1.34,1.34,0,0,1,22,24.25Zm11.44,1.27-5.25,5.26-1.71-1.72a1.33,1.33,0,0,0-1.88,0l-4.87,4.87a1.32,1.32,0,0,0-.39.94v1.54a.67.67,0,0,0,.67.67H40a.67.67,0,0,0,.67-.67V31.33a1.33,1.33,0,0,0-.39-.94l-4.87-4.87A1.35,1.35,0,0,0,33.48,25.52Zm5.37,9.79H21.15v-.26l4.43-4.42,2.65,2.65,6.19-6.19,4.43,4.42Z"
            />
          </svg>
        </div>

        <v-dialog v-model="dialog" width="auto">
          <v-card>
            <v-btn @click="dialog = false" class="product-image-dialog-btn--close">
              <v-icon>$vuetify.icons.clear</v-icon></v-btn
            >

            <img
              v-if="productImageUrl"
              loading="lazy"
              :src="productImageUrl"
              alt=""
              class="product-image-dialog-image mx-4 mb-2"
            />
          </v-card>
        </v-dialog>

        <div class="col-7">
          <v-card-title class="px-0 pt-0 color-black">
            {{ itemData.item.sku }}
          </v-card-title>
          <v-card-text class="px-0">
            {{ itemData.item.name.ces }}
            <span
              class="color-primary"
              :class="itemData.item.amount > 1 ? 'pa-1 amber color-red font-weight-bold' : ''"
            >
              ({{ itemData.item.amount }}x)
            </span>
          </v-card-text>

          <div v-if="modifyInterval && appealTime">
            <v-btn @click="stopChecking" color="primary">
              {{ $vuetify.lang.t(`$vuetify.check.uncheck`) }}
              ({{ appealTime }} s)
            </v-btn>
          </div>

          <div
            v-else-if="
              itemData.modification &&
              itemData.modification.reason_id === MODIFICATION_REASON_ID.NOT_FOUND_IN_STOCK &&
              !isSearched
            "
            class="d-flex flex-wrap gap-4"
          >
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.NOT_FOUND_CONFIRMED)"
              :color="modifiedAs === MODIFICATION_REASON.NOT_FOUND_CONFIRMED ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.NOT_FOUND_CONFIRMED ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.NOT_FOUND_CONFIRMED"
            >
              {{ $vuetify.lang.t(`$vuetify.check.notFound`) }}
            </v-btn>

            <v-btn class="ml-9" color="primary" :outlined="isModifiedAsError" @click="searched">
              {{ $vuetify.lang.t(`$vuetify.check.found`) }}
            </v-btn>
          </div>

          <div v-else class="d-flex flex-wrap gap-4">
            <v-btn
              @click="isModificationReasonsDialogOpen = true"
              :color="modifiedAs !== MODIFICATION_REASON.CHECKED ? 'red' : 'error'"
              :class="modifiedAs !== MODIFICATION_REASON.CHECKED ? 'v-btn--outlined' : 'bg-white'"
              :outlined="!isModifiedAsError"
            >
              {{ $vuetify.lang.t(`$vuetify.check.error`) }}
            </v-btn>

            <!--  CHECKED BUTTON  -->
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ml-9"
                  v-on="on"
                  @click="handleCheckedButtonClick(itemData)"
                  :color="modifiedAs === MODIFICATION_REASON.CHECKED ? 'green' : 'primary'"
                  :outlined="isModifiedAsError"
                >
                  {{ $vuetify.lang.t(`$vuetify.check.checked`) }}
                </v-btn>
              </template>
              <span> {{ $vuetify.lang.t('$vuetify.labels.enter') }} ↵ </span>
            </v-tooltip>
            <!-- end of checked button  -->
          </div>

          <p
            v-if="
              itemData.modification &&
              itemData.modification_reason &&
              itemData.modification.reason_id === MODIFICATION_REASON_ID.NOT_FOUND_IN_STOCK &&
              modifiedAs !== MODIFICATION_REASON.CHECKED
            "
            class="mt-4 px-3 py-1 w-fit error font-weight-bold white--text"
          >
            {{ itemData.modification_reason.label ? itemData.modification_reason.label.ces : '' }}
          </p>
        </div>
      </v-row>
    </v-container>
    <v-divider />

    <!--  MODIFICATION REASON DIALOG  -->
    <v-dialog v-model="isModificationReasonsDialogOpen" width="auto">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-wrap gap-4 pt-4">
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.DAMAGED)"
              :color="modifiedAs === MODIFICATION_REASON.DAMAGED ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.DAMAGED ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.DAMAGED"
            >
              {{ $vuetify.lang.t(`$vuetify.check.damaged`) }}
            </v-btn>
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.NOT_FOUND_CONFIRMED)"
              :color="modifiedAs === MODIFICATION_REASON.NOT_FOUND_CONFIRMED ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.NOT_FOUND_CONFIRMED ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.NOT_FOUND_CONFIRMED"
            >
              {{ $vuetify.lang.t(`$vuetify.check.notFound`) }}
            </v-btn>
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.SYSTEM_ERROR)"
              :color="modifiedAs === MODIFICATION_REASON.SYSTEM_ERROR ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.SYSTEM_ERROR ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.SYSTEM_ERROR"
            >
              {{ $vuetify.lang.t(`$vuetify.check.systemError`) }}
            </v-btn>
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.WRONG_SIZE)"
              :color="modifiedAs === MODIFICATION_REASON.WRONG_SIZE ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.WRONG_SIZE ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.WRONG_SIZE"
            >
              {{ $vuetify.lang.t(`$vuetify.check.wrongSize`) }}
            </v-btn>
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.WRONG_INCLUSION)"
              :color="modifiedAs === MODIFICATION_REASON.WRONG_INCLUSION ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.WRONG_INCLUSION ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.WRONG_INCLUSION"
            >
              {{ $vuetify.lang.t(`$vuetify.check.wrongInclusion`) }}
            </v-btn>
            <v-btn
              @click="checkProduct(MODIFICATION_REASON.OTHER)"
              :color="modifiedAs === MODIFICATION_REASON.OTHER ? 'red' : 'error'"
              :class="modifiedAs === MODIFICATION_REASON.OTHER ? 'v-btn--outlined' : 'bg-white'"
              :outlined="modifiedAs !== MODIFICATION_REASON.OTHER"
            >
              {{ $vuetify.lang.t(`$vuetify.check.other`) }}
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="isModificationReasonsDialogOpen = false">
            {{ $vuetify.lang.t(`$vuetify.check.close`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MODIFICATION_REASON from '../../common/enums/modificationReason';
import MODIFICATION_REASON_ID from '../../common/enums/modificationReasonId';

export default {
  name: 'ProductToCheck',

  props: {
    itemData: {
      type: Object,
      required: true,
    },

    modifiedAs: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },

    hideCheckedProducts: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      MODIFICATION_REASON,
      MODIFICATION_REASON_ID,
      dialog: false,
      isLoading: false,
      modifyTimeout: null,
      modifyingEnded: false,
      isModificationReasonsDialogOpen: false,
      isSearched: false,
      modifyInterval: null,
      appealTime: null,
    };
  },

  watch: {
    modifiedAs() {
      if (this.modifyTimeout) {
        clearTimeout(this.modifyTimeout);
      }

      this.modifyingEnded = false;

      this.modifyTimeout = setTimeout(() => {
        this.modifyingEnded = true;
      }, 2000);
    },
  },

  computed: {
    ...mapGetters({
      getOrder: 'stores/getOrder',
    }),

    productImageUrl() {
      const embedded = this.itemData.item._embedded;
      return (embedded && embedded.product_image_url) || null;
    },

    selectLoading() {
      return this.modifiedAs && this.hideCheckedProducts;
    },

    isModifiedAsError() {
      return this.modifiedAs !== null && this.modifiedAs !== MODIFICATION_REASON.CHECKED;
    },
  },

  methods: {
    handleCheckedButtonClick() {
      this.appealTime = 3;

      this.$emit(
        'check-product',
        this.itemData.item.id,
        this.itemData.item.sku,
        MODIFICATION_REASON.CHECKED,
        this.itemData.item.amount
      );

      this.modifyInterval = setInterval(() => {
        this.appealTime--;

        if (this.appealTime === 0) {
          clearInterval(this.modifyInterval);
        }
      }, 1000);

      this.isLoading = true;
    },

    checkProduct(typeOfCheck) {
      this.appealTime = 3;

      this.$emit(
        'check-product',
        this.itemData.item.id,
        this.itemData.item.sku,
        typeOfCheck,
        this.itemData.item.amount
      );

      this.modifyInterval = setInterval(() => {
        this.appealTime--;

        if (this.appealTime === 0) {
          clearInterval(this.modifyInterval);
        }
      }, 1000);

      this.isModificationReasonsDialogOpen = false;

      this.isLoading = true;
    },

    searched() {
      this.isSearched = true;
    },

    stopChecking() {
      clearInterval(this.modifyInterval);
      this.modifyInterval = null;

      this.$emit('uncheck-product', this.itemData.item.id);
    },
  },

};
</script>

<style scoped>
.error-product-card {
  background: rgb(255, 82, 82, 30%);
}

.is-loading {
  opacity: 0;
  transition: opacity 2s;
}

.is-hidden {
  display: none;
}

.product-image {
  max-height: 176px;
  object-fit: contain;
}

.product-image-dialog-btn--close {
  display: block;
  width: fit-content;
  padding: 1rem 1.5rem;
  margin-left: auto;
  background: none !important;
  box-shadow: none;
}

.product-image-dialog-image {
  max-width: 70vw;
  max-height: 70vh;
}
</style>
